import React from 'react';
import { Button } from 'antd';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { peekSsoEmail } from '../../services/mobileSso';
import './LoginScreen.css';

const SsoUnavailableScreen: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || peekSsoEmail();

  const usePassword = () => {
    const params = new URLSearchParams();
    if (email) params.set('email', email);
    params.set('focus', 'password');
    navigate(`/login?${params.toString()}`, { replace: true });
  };

  const tryDifferentEmail = () => {
    navigate('/login', { replace: true });
  };

  return (
    <div className="login-container sso-status-screen">
      <div className="sso-status-content">
        <h1 className="sso-status-title">Can&apos;t sign in with SSO</h1>
        <p className="sso-status-body">
          This email isn&apos;t set up for single sign-on. Contact your administrator, or sign in
          with your password instead.
        </p>
        <Button type="primary" block size="large" onClick={usePassword} style={{ marginBottom: 12 }}>
          Use password instead
        </Button>
        <Button block size="large" onClick={tryDifferentEmail}>
          Try a different email
        </Button>
      </div>
    </div>
  );
};

export default SsoUnavailableScreen;
